import { useCallback, type FC, type PropsWithChildren } from 'react';
import { FeatureFlagsContext, type FeatureFlags } from './FeatureFlagsContext';
import { FEATURE_FLAGS } from '@Constants/featureFlagConstants';

export const FeatureFlagsProvider: FC<PropsWithChildren> = ({ children }) => {
    const isFeatureEnabled = useCallback((featureName: keyof FeatureFlags) => {
        return FEATURE_FLAGS[featureName];
    }, []);

    return (
        <FeatureFlagsContext.Provider value={{ featureFlags: FEATURE_FLAGS, isFeatureEnabled }}>
            {children}
        </FeatureFlagsContext.Provider>
    );
};
